<script>
    import { onMount, onDestroy, createEventDispatcher } from 'svelte'
    import { landscape } from '../../stores/bounds'

    const dispatch = createEventDispatcher ()

    let supportedViewportchangeEvent = "onorientationchange" in window ? 'resize' : 'orientationchange'
    let isResizedBased = supportedViewportchangeEvent === 'resize'
    let isDevicePortrait = true;
    let deviceWidth = 0
    let deviceHeight = 0
    let prevOrientation = null

    const isPortrait = () => {
        return isResizedBased ? (window.orientation === 0 || window.orientation === 180) : (window.innerHeight > window.innerWidth);
    }
    const updateOrientation = (force) => {
        const currOrientation = isPortrait ()
        
        isDevicePortrait = isPortrait ()
        deviceWidth = window.innerWidth
        deviceHeight = window.innerHeight

        // dispatch ('change', {
        //     portrait: isDevicePortrait,
        //     isOrientationChange: prevOrientation !== currOrientation,
        //     width: deviceWidth,
        //     height: deviceHeight
        // })
        landscape.set (isDevicePortrait === false)    
        prevOrientation = currOrientation
    }
    const onOrientationChange = (event) => setTimeout (updateOrientation, 20)

    onMount (() => {
        updateOrientation ();
        window.addEventListener (supportedViewportchangeEvent, onOrientationChange)
    })

    onDestroy (() => {
        window.removeEventListener (supportedViewportchangeEvent, onOrientationChange)
    })
</script>

